const industries = [
  {
    label: "Aerospace & Defense",
    value: "Aerospace & Defense",
    targetType: "Industry"
  },
  {
    label: "Agriculture & Forestry",
    value: "Agriculture & Forestry",
    targetType: "Industry"
  },
  { label: "Automotive", value: "Automotive", targetType: "Industry" },
  {
    label: "Business Services",
    value: "Business Services",
    targetType: "Industry"
  },
  { label: "Chemicals", value: "Chemicals", targetType: "Industry" },
  { label: "Construction", value: "Construction", targetType: "Industry" },
  {
    label: "Distribution, Wholesale, Retail",
    value: "Distribution, Wholesale, Retail",
    targetType: "Industry"
  },
  { label: "Education", value: "Education", targetType: "Industry" },
  {
    label: "Electrical Equipment",
    value: "Electrical Equipment",
    targetType: "Industry"
  },
  { label: "Electronics", value: "Electronics", targetType: "Industry" },
  {
    label: "Engineering & Technical Services",
    value: "Engineering & Technical Services",
    targetType: "Industry"
  },
  {
    label: "Food, Beverage, Tobacco",
    value: "Food, Beverage, Tobacco",
    targetType: "Industry"
  },
  {
    label: "Government & Military",
    value: "Government & Military",
    targetType: "Industry"
  },
  { label: "Machinery", value: "Machinery", targetType: "Industry" },
  {
    label: "Manufacturing (not specified)",
    value: "Manufacturing (not specified)",
    targetType: "Industry"
  },
  {
    label: "Medical & Healthcare",
    value: "Medical & Healthcare",
    targetType: "Industry"
  },
  {
    label: "Metals - Raw, Formed, Fabricated",
    value: "Metals - Raw, Formed, Fabricated",
    targetType: "Industry"
  },
  {
    label: "Mining, Oil & Gas, Quarrying",
    value: "Mining, Oil & Gas, Quarrying",
    targetType: "Industry"
  },
  {
    label: "Paper, Paper Products & Printing",
    value: "Paper, Paper Products & Printing",
    targetType: "Industry"
  },
  {
    label: "Plastics & Rubber",
    value: "Plastics & Rubber",
    targetType: "Industry"
  },
  {
    label: "Textiles, Apparel, Leather",
    value: "Textiles, Apparel, Leather",
    targetType: "Industry"
  },
  {
    label: "Transportation & Logistics",
    value: "Transportation & Logistics",
    targetType: "Industry"
  },
  {
    label: "Utilities & Telecommunications",
    value: "Utilities & Telecommunications",
    targetType: "Industry"
  },
  { label: "Other", value: "Other", targetType: "Industry" }
];

export default industries;
